const test = false;

export const MeanStatus = (props) => {
  const { row } = props;

  if (test) {
    row.is_secondentry = true;
    row.jam_info = {
      jam_id: 'jam id',
      strategy: 'activated_zone',
      activated_at: 1775217000,
    };
  }

  /**
   * is jam
   * @param {*} jam_info
   * @returns
   */
  function isJam(jam_info) {
    if (!jam_info) {
      return false;
    }
    const strategy = jam_info?.strategy;
    if (!strategy) {
      return false;
    }
    return ['activated_zone', 'entry_jam', 'paid'].includes(strategy);
  }

  const is_jam = isJam(row.jam_info);

  const out = [];
  if (row.is_mean_blocked) {
    if (row.is_suspicious) {
      out.push(<img title="Подозрительный проезд" className="td-icon" key="ms1" src="/images/red_lock_icon.png" alt="" />);
    } else {
      out.push(<img title="Заблокированный проезд" className="td-icon" key="ms2" src="/images/black_lock_icon.png" alt="" />);
    }
  }
  if (row.is_handicapped) {
    out.push(<img title="Льгота" className="td-icon td-icon--big" key="ms3" src="/images/tax-free.png" alt="" />);
  }

  if (row.is_secondentry) {
    out.push(<img title="Повторный проезд" className="td-icon td-icon--big" key="ms4" src="/images/second.png" style={{ height: '9px' }} alt="" />);
  }

  if (is_jam) {
    out.push(<img title="Затор" className="td-icon td-icon--big" key="ms4" src="/images/jam.png" style={{ height: '11px' }} alt="" />);
  }

  return !out.length ? null : out;
};
